import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import CheckoutPage from "./pages/CheckoutPage";
import Loader from "./Loader/Loader";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchUserDetails } from "./api/apiFunction";
import { useStore } from "./lib/userDetails/UserDetails";
import AllEvents from "./pages/AllEvents";
import MyRegistration from "./pages/MyRegistration";
const AuthPage = lazy(() => import("@/pages/AuthPage"));
const HomePage = lazy(() => import("@/pages/HomePage"));
const EventPage = lazy(() => import("@/pages/EventPage"));
const MyProfile = lazy(() => import("@/pages/MyProfile"));
import NavigationHandler from "./components/navigation/NavigationHandler";
const Policies = lazy(() => import("@/pages/Policies"));
const TermAndConditions = lazy(() => import("@/pages/TermAndConditions"));
const ContactUsPage = lazy(() => import("./pages/ContactUsPage"));
const ChangePasswordPage = lazy(() => import("./pages/ChangePasswordPage"));
// @ts-ignore
import { Toaster } from "@/components/ui/toaster";
import Cookies from "js-cookie";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster as HotToaster } from "react-hot-toast";

function App() {
  const { setUser, isAuthenticated, setAuthenticated } = useStore();
  const queryClient = useQueryClient();
  const { data, isLoading, isSuccess } = useQuery({
    enabled: !isAuthenticated,
    retry: true,
    queryKey: ["user-details"],
    queryFn: () => fetchUserDetails(setAuthenticated, setUser),
  });
  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({ queryKey: ["all-members"] });
    }
  }, [isSuccess, setAuthenticated]);

  const token = Cookies.get("token");

  const PrivateRoute = ({ element }: { element: JSX.Element }) => {
    return token ? element : <Navigate to="/auth/login/email" />;
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <section>
        <BrowserRouter>
          <NavigationHandler data={data} />
          <ScrollToTop />
          {/* <RefreshHandler setIsAuthenticatied={isAuthenticated} /> */}
          <Routes>
            <Route
              path="/auth/*"
              element={
                <Suspense fallback={<Loader />}>
                  <AuthPage />
                </Suspense>
              }
            />

            <Route
              path="/"
              element={
                <Suspense fallback={<Loader />}>
                  {isLoading ? <Loader /> : <HomePage />}
                </Suspense>
              }
            />
            <Route
              path="/all-events"
              element={
                <Suspense fallback={<Loader />}>
                  <AllEvents />
                </Suspense>
              }
            />
            <Route
              path="/event/:id"
              element={
                <Suspense fallback={<Loader />}>
                  <EventPage />
                </Suspense>
              }
            />
            <Route
              path="/my-profile"
              element={
                <Suspense fallback={<Loader />}>
                  <PrivateRoute element={<MyProfile data={data} />} />
                </Suspense>
              }
            />

            <Route
              path="/checkout/:id"
              element={
                <Suspense fallback={<Loader />}>
                  <PrivateRoute element={<CheckoutPage />} />
                </Suspense>
              }
            />

            <Route
              path="/my-registration"
              element={
                <Suspense fallback={<Loader />}>
                  <PrivateRoute element={<MyRegistration />} />
                </Suspense>
              }
            />
            <Route
              path="/change-password"
              element={
                <Suspense fallback={<Loader />}>
                  <ChangePasswordPage />
                </Suspense>
              }
            />
            <Route
              path="/contact-us"
              element={
                <Suspense fallback={<Loader />}>
                  <ContactUsPage />
                </Suspense>
              }
            />

            <Route
              path="/policy"
              element={
                <Suspense fallback={<Loader />}>
                  <Policies />
                </Suspense>
              }
            />

            <Route
              path="/terms"
              element={
                <Suspense fallback={<Loader />}>
                  <TermAndConditions />
                </Suspense>
              }
            />
          </Routes>

          <Toaster />
          <HotToaster />
        </BrowserRouter>
      </section>
    </>
  );
}

export default App;
